/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class ServiceNowConfigurationComponent {
    getFixupPrototypeFunction() { return ServiceNowConfigurationComponent.fixupPrototype; }

    static newInstance(model: Partial<ServiceNowConfigurationComponent>): ServiceNowConfigurationComponent {
        let obj = Object.assign(new ServiceNowConfigurationComponent(), model);
        ServiceNowConfigurationComponent.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<ServiceNowConfigurationComponent>): ServiceNowConfigurationComponent {
        if (!model) return null;
        return ServiceNowConfigurationComponent.newInstance(<ServiceNowConfigurationComponent> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: ServiceNowConfigurationComponent) {
        if (!obj) return;

        models.ServiceNowConfigurationComponent.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: ServiceNowConfigurationComponent): boolean {
        Object.setPrototypeOf(obj, ServiceNowConfigurationComponent.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Source for ServiceNow ToolsConfiguration setting
     */
    source: models.ServiceNowToolsConfigurationSource;

    /**
     * Name for ServiceNow ToolsConfiguration setting
     */
    name: models.ServiceNowToolsConfigurationName;

    /**
     * Value for ServiceNow ToolsConfiguration setting
     */
    value: string;

}
